import { render } from "./HelpModal.vue?vue&type=template&id=08e9c709&scoped=true"
import script from "./HelpModal.vue?vue&type=script&lang=js"
export * from "./HelpModal.vue?vue&type=script&lang=js"

import "./HelpModal.vue?vue&type=style&index=0&id=08e9c709&lang=scss&scoped=true"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e9c709"]])

export default __exports__